import { render, staticRenderFns } from "./OTRequests.vue?vue&type=template&id=71531ac6&scoped=true"
import script from "./OTRequests.vue?vue&type=script&lang=js"
export * from "./OTRequests.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/layout/Request.css?vue&type=style&index=0&id=71531ac6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71531ac6",
  null
  
)

export default component.exports